/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  var $window = $(window),
      $windowHeight = $window.height(),
      $windowWidth = $window.width(),
      $scrollTop = 0,
      $isMobile = ($windowWidth<768) ?  true : false;

  function preventDefault(e) {
    e = e || window.event;
    if(e.preventDefault) {
      e.preventDefault();
    }
    e.returnValue = false;  
  }
  function disableScroll() {
    if(window.addEventListener) {
      window.addEventListener('DOMMouseScroll', preventDefault, false);
    }
    window.onwheel = preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
    window.ontouchmove  = preventDefault; // mobile
  }
  function enableScroll() {
    if(window.removeEventListener) {
      window.removeEventListener('DOMMouseScroll', preventDefault, false);
    }
    window.onmousewheel = document.onmousewheel = null; 
    window.onwheel = null; 
    window.ontouchmove = null;    
  }
  function getParameterByName(name, url) {
    if(!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if(!results) return null;
    if(!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  function setGallerySection($paginationLink, $startIndex, $endIndex, $activeIndex) {
    $('#listing-gallery .pagination-links a.active').removeClass('active');
    $paginationLink.addClass('active');

    if($paginationLink.hasClass('streetview') || $paginationLink.hasClass('aerialview')) {
      $('#listing-gallery, .zoom-overlay').addClass('streetview-view');
    
      if($galleryMap) {
        google.maps.event.trigger($galleryMap, 'resize');
        $galleryMap.setCenter($mapCenter);
        $galleryMap.setZoom(19);
      }
      if($zoomMap) {
        google.maps.event.trigger($zoomMap, 'resize');
        $zoomMap.setCenter($mapCenter);
        $zoomMap.setZoom(19);
      }
    } else {
      $('#listing-gallery, .zoom-overlay').removeClass('streetview-view');
    }

    $('#num').html($activeIndex-$startIndex+1);
    $('#of').html($endIndex-$startIndex+1);
  }

  function adjustZoomGallery() {
    var $zoomGalleryRatio = 753/1000,
        $zoomGalleryWidth = $('.zoom-gallery').width(),
        $zoomGalleryHeight = $('.zoom-gallery').width(),
        $windowRatio = $windowHeight/$windowWidth;

    //if($windowWidth<$zoomGalleryWidth+140 || $windowHeight<$zoomGalleryHeight+140) {
      if($windowRatio>$zoomGalleryRatio) {
        $zoomGalleryWidth = $windowWidth-140;
        $zoomGalleryHeight = Math.floor($zoomGalleryWidth*$zoomGalleryRatio);
      } else {
        $zoomGalleryHeight = $windowHeight-140;
        $zoomGalleryWidth = Math.floor((1/$zoomGalleryRatio)*$zoomGalleryHeight);
      }
      $('.zoom-overlay').css({ width:$zoomGalleryWidth, height:$zoomGalleryHeight, marginTop:-($zoomGalleryHeight/2), marginLeft:-($zoomGalleryWidth/2) });
      $('.zoom-overlay .swiper-container, .zoom-overlay .swiper-slide, .zoom-overlay iframe').css({ width:$zoomGalleryWidth, height:$zoomGalleryHeight });
    //}

    if($zoomMap) {
      google.maps.event.trigger($zoomMap, 'resize');
      $zoomMap.setCenter($mapCenter);
      $zoomMap.setZoom(20);
    }
  }

  function adjustFrontFeature() {
    var $windowRatio = $windowHeight/$windowWidth;

    var $feature = $('.front-feature'),
        $featureHeight = $windowHeight,
        //$featureImage = $feature.find('img'),
        $featureImage = $feature.find('.feature-image'),
        $featureContent = $feature.find('.feature-content');

    $feature.css({ height:$featureHeight });
    $featureImage.animate({ opacity:1 }, 'slow');
    $featureContent.animate({ opacity:1 }, 'slow', function() {
      setTimeout(function() {
        $('.scroll').animate({ bottom:0 }, 'slow');
      }, 1000);
    });
  }

  function adjustFooter() {
    $('.footer').css({ height:'auto' });

    var $contentHeight = $('.wrap').outerHeight() + $('.footer').outerHeight();

    if($contentHeight<$windowHeight) {
      $('.footer').css({ height:($windowHeight-$contentHeight+$('.footer').outerHeight()) });
    }
  }

  function adjustHeaderContact() {
    if(!$isMobile && !$('.nav-primary li.contact').hasClass('current-menu-item')) {
      $('.header-contact').css({ maxHeight:$windowHeight-$('.header').height(), display:'block' });
      if($('.header').hasClass('contact-open')) {
        //$('.header-contact').css({ bottom:-$('.header-contact').outerHeight() });
      } else {
        $('.header-contact').css({ bottom:0 });
      }
    } else {
      $('.header-contact').hide();
    }
  }

  $window.resize(function() {
    $windowHeight = $window.height();
    $windowWidth = $window.width();
    $isMobile = ($windowWidth<=768) ?  true : false;

    adjustFooter();
  });
  $window.scroll(function() {
    $scrollTop = $window.scrollTop();
  });

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        /* mobile navigation */
        $('.menu-toggle').click(function(e) {
          e.preventDefault();
          disableScroll();

          $('.mobile-nav').fadeIn();
        });
        $('.mobile-nav .close').click(function(e) {
          e.preventDefault();
          enableScroll();

          $('.mobile-nav').fadeOut();
        });

        adjustHeaderContact();
        $window.resize(adjustHeaderContact);

        $('.nav-primary li.contact a').click(function(e) {
          e.preventDefault();

          if(!$isMobile && !$('.nav-primary li.contact').hasClass('current-menu-item')) {
            if($('.header').hasClass('contact-open')) {
              $('.header-contact').animate({ bottom:0 });
              $('.header').removeClass('contact-open');
              $('.contact-mask').fadeOut();
            } else {
              $('.header-contact').animate({ bottom:-$('.header-contact').outerHeight() }, function() {
                $('.header-contact').css({ bottom:'auto' });
              });
              $('.header').addClass('contact-open');
              $('.contact-mask').fadeIn();
            }
          }
        });
        $('.contact-mask, .header-contact .close').click(function(e) {
          e.preventDefault();
          
          $('.header-contact').animate({ bottom:0 });
          $('.header').removeClass('contact-open');
          $('.contact-mask').fadeOut();
        })

        /* adjust footer height */
        adjustFooter();

        /* lazyload images */
        $('ul.grid.properties img.lazy').lazyload({
          effect:'fadeIn'
        });

        /* property swipers */
        if($('.swiper-container.properties').length>0) {
          $('.swiper-container.properties img.lazy').each(function() {
            $(this).attr('src', $(this).data('original')).removeClass('lazy');
          })
          $('.swiper-container.properties').swiper({
            loop:true
          });
        }

        /* scroll down to property tabs */
        var $show = getParameterByName('show');
        if($show) {
          TweenLite.to(window, 1, {scrollTo:{y:$('.property-tabs').offset().top-$('.header').outerHeight()-20}, ease:Power2.easeOut});
        }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        /* adjust landing slides */
        $('.front-feature img').imagesLoaded(adjustFrontFeature);
        $window.resize(function() {
          if(!$isMobile) {
            adjustFrontFeature();
          }
        });
        window.addEventListener('orientationchange', function() {
          adjustFrontFeature();
        }, false);

        /* skrollr */
        if($('html').hasClass('no-touchevents')) var $s = skrollr.init();

        /* trigger fixed header */
        $window.scroll(function() {
          if($scrollTop>=$windowHeight) {
            $('.header').addClass('fixed-nav');
          } else {
            $('.header').removeClass('fixed-nav');
          }
        });

        /* scroll down */
        $('.scroll').click(function(e) {
          e.preventDefault();

          TweenLite.to(window, 2, {scrollTo:{y:$('.front-feature').outerHeight()}, ease:Power2.easeOut});
          //$('html, body').animate({ scrollTop:$('.front-feature').outerHeight() }, 'slow');
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'single_property': {
      init: function() {
        /* tabs */
        $('.tabs a').click(function(e) {
          e.preventDefault();

          var $tab = $(this);

          if($tab.hasClass('active')) {
            if($('.tabs').hasClass('open')) {
              $('.tabs').removeClass('open');
            } else {
              $('.tabs').addClass('open');
            }
          } else {
            $('.tabs a.active').removeClass('active');
            $('.tab-content div.active').removeClass('active');
            $tab.addClass('active');
            $($tab.attr('href')).addClass('active');
            $('.tabs').removeClass('open');
          }
        });

        /* mortgage calculator */
        $('.mortgage-calculator').click(function(e) {
          e.preventDefault();

          $('.calculator-overlay input[name="principal_mortgage"]').val(parseInt($(this).data('price')));
          $('.calculator-overlay').css({ top:$scrollTop+$('header').height()-1 });
          $('.calculator-overlay, .overlay-mask').fadeIn();
        });
        $('.overlay .close, .overlay-mask').click(function(e) {
          e.preventDefault();

          $('.overlay, .overlay-mask').fadeOut(function() {
            $('.zoom-overlay').css({ opacity:0 });
          });
        });
        $('.calculator-overlay button').click(function(e) {
          e.preventDefault();

          $('.calculator-overlay input').each(function() {
            if(!$.isNumeric($(this).val())) {
              $(this).addClass('error');
            } else {
              $(this).removeClass('error');
            }
          });

          if($('.calculator-overlay input.error').length>0) {
            $('.calculator-overlay .message').fadeIn();
          } else {
            $('.calculator-overlay .message').fadeOut();

            var $principal_mortgage = $('.calculator-overlay input[name="principal_mortgage"]').val(),
                $interest_rate = $('.calculator-overlay input[name="interest_rate"]').val(),
                $years = $('.calculator-overlay input[name="years"]').val(),
                $temp_rate =  $interest_rate/1200,
                $temp_term = $years*12,
                $monthly_payment = ($principal_mortgage*($temp_rate*Math.pow(1+$temp_rate,$temp_term)))/(Math.pow(1+$temp_rate,$temp_term)-1);

            $('#principal_mortgage').html('$'+parseFloat($principal_mortgage).formatMoney(2, '.', ','));
            $('#interest_rate').html('[ '+parseFloat($interest_rate).toFixed(2)+'% ]*');
            $('#years').html($years+' years');
            $('#monthly_payment').html('$'+parseFloat($monthly_payment).formatMoney(2, '.', ','));
            $('.calculator-overlay .results').fadeIn();
          }
        });
        $('.calculator-overlay .reset').click(function(e) {
          e.preventDefault();

          $('.calculator-overlay input').val('');
          $('.calculator-overlay .message, .calculator-overlay .results').fadeOut();
        });

        /* listing - gallery */
        if($isMobile) {
          $('#listing-gallery .swiper-slide.aerial-slide').remove();
          $('.zoom-overlay .swiper-slide.aerial-slide').remove();
          $('#listing-gallery .pagination-links a.aerialview').remove();
          $('#listing-gallery .swiper-slide.street-slide').remove();
          $('.zoom-overlay .swiper-slide.street-slide').remove();
          $('#listing-gallery .pagination-links a.streetview').remove();
        }
        var $listingGalleryRatio = 497/660,
            $listingGalleryWidth = $('#listing-gallery').width(),
            $listingGalleryHeight = $listingGalleryWidth*$listingGalleryRatio;

        if($windowWidth<768) $listingGalleryHeight = ($listingGalleryWidth-10)*$listingGalleryRatio;

        $('#listing-gallery .swiper-container, #listing-gallery .swiper-slide, #listing-gallery iframe').css({ width:$listingGalleryWidth, height:$listingGalleryHeight, opacity:1 });

        $window.resize(function() {
          var $listingGalleryRatio = 497/660,
              $listingGalleryWidth = $('#listing-gallery').width(),
              $listingGalleryHeight = $listingGalleryWidth*$listingGalleryRatio;

          if($windowWidth<768) $listingGalleryHeight = ($listingGalleryWidth-10)*$listingGalleryRatio;

          $('#listing-gallery .swiper-container, #listing-gallery .swiper-slide, #listing-gallery iframe').css({ width:$listingGalleryWidth, height:$listingGalleryHeight });

          adjustZoomGallery();
        });

        if($('#listing-gallery .swiper-slide').length>1) {
          var $gallerySwiperOptions = {
            mode:'horizontal',
            loop:true,
            calculateHeight:true,
            simulateTouch:false,
            onInit:function(swiper) {
              var $activeIndex = swiper.activeIndex,
                  $paginationLink = $('#listing-gallery .pagination-links a').first(),
                  $startIndex = $paginationLink.data('start'),
                  $endIndex = $paginationLink.data('end');

              setGallerySection($paginationLink, $startIndex, $endIndex, $activeIndex);
            },
            onSlideChangeEnd:function(swiper) {
              var $activeIndex = swiper.activeIndex;

              if($activeIndex==0) {
                var $paginationLink = $('#listing-gallery .pagination-links a').last(),
                    $startIndex = $paginationLink.data('start'),
                    $endIndex = $paginationLink.data('end');

                setGallerySection($paginationLink, $startIndex, $endIndex, $endIndex);
              } else if($activeIndex==($('#listing-gallery .swiper-slide').length-1)) {
                var $paginationLink = $('#listing-gallery .pagination-links a').first(),
                    $startIndex = $paginationLink.data('start'),
                    $endIndex = $paginationLink.data('end');

                setGallerySection($paginationLink, $startIndex, $endIndex, $startIndex);
              } else {
                $('#listing-gallery .pagination-links a').each(function() {
                  var $paginationLink = $(this),
                      $startIndex = $paginationLink.data('start'),
                      $endIndex = $paginationLink.data('end');

                  console.log($paginationLink.text()+': '+$startIndex+' '+$activeIndex+' '+$endIndex);

                  if($activeIndex >= $startIndex && $activeIndex <= $endIndex) {
                    setGallerySection($paginationLink, $startIndex, $endIndex, $activeIndex);
                  }
                });
              }
            }
          };
          //if($windowWidth<768) $gallerySwiperOptions.loop = true;

          $gallerySwiper = $('#listing-gallery .swiper-container').swiper($gallerySwiperOptions);
          $('#listing-gallery .swiper-prev').click(function() {
            $gallerySwiper.slidePrev();
          });
          $('#listing-gallery .swiper-next').click(function() {
            $gallerySwiper.slideNext();
          });
          $('#listing-gallery .pagination-links a').click(function(e) {
            e.preventDefault();

            var $paginationLink = $(this),
                $startIndex = $paginationLink.data('start'),
                $endIndex = $paginationLink.data('end');
            $gallerySwiper.slideTo($startIndex, 0);

            setGallerySection($paginationLink, $startIndex, $endIndex, $startIndex);
          });
        } else {
          $('#listing-gallery .swiper-prev, #listing-gallery .swiper-next, #listing-gallery .pagination-count').remove();
        }

        if($('.zoom-overlay .swiper-slide').length>0) {
          /* listing - zoom */
          adjustZoomGallery();

          if($('.zoom-overlay .swiper-slide').length>1) {
            $zoomSwiper = $('.zoom-overlay .swiper-container').swiper({
              mode:'horizontal',
              loop:true,
              calculateHeight:true,
              simulateTouch:false,
              onSlideChangeStart:function(swiper) {
              }
            });
            $('.zoom-overlay .swiper-prev').click(function() {
              $zoomSwiper.slidePrev();
              $gallerySwiper.slidePrev();
            });
            $('.zoom-overlay .swiper-next').click(function() {
              $zoomSwiper.slideNext();
              $gallerySwiper.slideNext();
            });
          } else {
            $('.zoom-overlay .swiper-prev, .zoom-overlay .swiper-next').remove();
          }

          $('a.zoom').click(function(e) {
            e.preventDefault();

            $('.zoom-overlay').show();
            $zoomSwiper.update();
            $zoomSwiper.slideTo($gallerySwiper.activeIndex, 0);
            $('.zoom-overlay, .zoom-overlay .swiper-slide').animate({ opacity:1 });

            if($('.zoom-overlay .streetview-iframe').attr('src')=='') {
              $('.zoom-overlay .streetview-iframe').attr('src', $('.pagination-links .streetview').attr('href'));
            }
            if($('.zoom-overlay .aerial-iframe').attr('src')=='') {
              $('.zoom-overlay .aerial-iframe').attr('src', $('.pagination-links .aerialview').attr('href'));
            }

            if($zoomMap) {
              google.maps.event.trigger($zoomMap, 'resize');
              $zoomMap.setCenter($mapCenter);
              $zoomMap.setZoom(20);
            }
            $('.zoom-overlay, .overlay-mask').fadeIn();
          });

          /*$('#zoom-gallery').overlay({
            expose:{ color:'#ffffff', loadSpeed:150, opacity:0.85 },
            top:'center',
            left:'center',
            fixed:true,
            onClose:function(event) {
              $gallerySwiper.swipeTo($zoomSwiper.activeIndex-1,0);
              $('#zoom-gallery').animate({opacity:0});
            },
            onLoad:function(event) {
              $zoomSwiper.resizeFix();
              $zoomSwiper.swipeTo($gallerySwiper.activeIndex-1,0);
              $('#zoom-gallery').animate({opacity:1});

              if($('#zoom-gallery .streetview-iframe').attr('src')=='') $('#zoom-gallery .streetview-iframe').attr('src', $('.pagination-links .streetview').attr('href'));
              if($('#zoom-gallery .aerial-iframe').attr('src')=='') $('#zoom-gallery .aerial-iframe').attr('src', $('.pagination-links .aerialview').attr('href'));

              if($zoomMap) {
                google.maps.event.trigger($zoomMap, 'resize');
                $zoomMap.setCenter($mapCenter);
                $zoomMap.setZoom(20);
              }
            }
          });
          $('a.zoom').click(function(e) {
            e.preventDefault();
            $('#zoom-gallery').overlay().load();
          });*/
        }
      }
    },
    'single_professional': {
      init: function() {
        /* expand bio */
        $('.read-more').click(function(e) {
          e.preventDefault();

          $('.bio-excerpt').hide();
          $('.bio-content').fadeIn();
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

Number.prototype.formatMoney = function(c, d, t){
var n = this, 
    c = isNaN(c = Math.abs(c)) ? 2 : c, 
    d = d == undefined ? "." : d, 
    t = t == undefined ? "," : t, 
    s = n < 0 ? "-" : "", 
    i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "", 
    j = (j = i.length) > 3 ? j % 3 : 0;
  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 };